// =====================================================================
// Assessment Center — Auth module: route guard.
// =====================================================================
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import type { Role } from "./types";

export function RequireRole({ role, children }: { role: Role; children: React.ReactNode }) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/" replace />;
  if (user.role !== role) {
    return (
      <Navigate
        to={user.role === "student" ? "/student/assessment-center" : "/instructor/assessment-center"}
        replace
      />
    );
  }
  return <>{children}</>;
}
